import React from 'react'
import "./sectionWhoWeAre.scss"

//Imagens:
import ImgSectionWhoWeAre from "../../../assets/whoWeAre/whoWeAre.png"
import { useTranslation } from 'react-i18next'

function SectionWhoWeAre() {
  const { t } = useTranslation()

  return (
    <div className='container-section-who-we-are'>
      <div className='img-section-who-we-are'>
        <img src={ImgSectionWhoWeAre} alt="" />
      </div>
      <div className='texts-section-who-we-are'>
        <h1>{t("home.who_we_are.title")}</h1>
        <p>{t("home.who_we_are.section_text_1")}</p>
        <p>{t("home.who_we_are.section_text_2")}</p>
        <p>{t("home.who_we_are.section_text_3")}</p>
      </div>
    </div>
  )
}

export default SectionWhoWeAre